// @ts-nocheck
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { node } from "~/util/dom";
import ActivityDetail from "./detail";
import ActivitiesList, { setSEO as setListSEO } from "./list";
import { _ } from "~/i18n";

export default class Activities {
	constructor() {
		this._detail = new ActivityDetail();
		this._list = new ActivitiesList();
		this._active = false;
		this._activecontent = this._list;
		this._actualContent = this._list;
		this._dom = {
			container: node("div", { className: "activity-main-cont activity-main-cont2" }),
		};
		this._preventLoad = false;
		this._isOGPrint = false;

		const watchUser = watch(store.getState, "user", watchCurrentUser);

		this._storeUnsubscribe = store.subscribe(watchUser((newUser, oldUser) => {
			// odhlasil se, nebo se prepnul z uzivatele na uzivatele - vynulujeme stav, jinak ne
			if ((oldUser.user.userPublicId && newUser.user.userPublicId !== oldUser.user.userPublicId) || newUser.user.state !== "green") {
				this.state = {};
			}
		}));
	}

	destroy() {
		this.clear();
		this._dom.container.remove();
		this._storeUnsubscribe();
	}

	get isOGPrint() {
		return this._isOGPrint;
	}

	activate(actState = {}) {
		const { user } = store.getState().user;

		if (user.state !== "green") {
			this._list.clear();
		}
		if (this._active) {
			return this;
		}

		this._list.zoomToItems = !actState.disableZoom && !Mapy.getComponent("history").isFromHistory();
		this._list.activate();
		this._detail.activate();

		this._appendContent();

		this.setSEO();

		this._active = true;

		Mapy.getComponent("logger").log("view", { text: "activities" });

		return this;
	}

	deactivate() {
		if (!this._active) {
			return this;
		}

		this._list.deactivate();
		this._detail.deactivate();

		this._active = false;

		return this;
	}

	get isActive() {
		return this._active;
	}

	clear() {
		this._list.clear();
		this._detail.clearTid();
		this._detail.clear();
	}

	get container() {
		return this._dom.container;
	}

	set state(state) {
		this._isOGPrint = state.p === "3";

		if (("mid" in state && state.mid !== "") || ("likeData" in state && state.likeData)) {
			this._activecontent = this._detail;
			this._detail.state = {
				...state,
				...state.backTitle ? { backTitle: state.backTitle } : {},
				...state.backAction ? { backAction: state.backAction } : {},
			};
		} else {
			this._activecontent = this._list;
			this._list.state = state;
		}

		this._appendContent();
	}

	get state() {
		return {
			...this._list.state,
			...this._detail.state,
		};
	}

	/**
	 * vraci data ulozena v moje mapy
	 * @return {Object} data
	 */
	get likeData() {
		return this._detail.likeData;
	}

	get list() {
		return this._list;
	}

	/**
	 * data pro sdileni
	 * @return {Object} data
	 */
	get shareData() {
		return {
			title: _("mymap.switcher.activities"),
			type: "activities-root",
			...this._actualContent === this._detail ? this._actualContent.shareData : {},
		};
	}

	/**
	 * zmena verejnosti
	 * @param  {Boolean} state verejnost
	 */
	changePublic(state) {
		if (this._actualContent === this._detail) {
			this._detail.changePublic(state);
		}
	}

	setSEO() {
		if (!this.isActive) {
			return;
		}

		if (this._list.visible) {
			setListSEO();
		} else if (this._detail.visible) {
			this._detail.setSEO();
		}
	}

	_appendContent() {
		const { user } = store.getState().user;

		if (this._activecontent === this._detail) {
			if (this._actualContent === this._detail) {
				this._detail.show();
				this._list.hide();
			} else {
				this._actualContent = this._detail;

				if (!this._isOGPrint && user.state !== "green") {
					Mapy.getComponent("mymaps").activeComponent(this, true);
				}

				this._dom.container.appendChild(this._detail.container);
				this._list.container.remove();

				this._detail.show();
				this._list.hide();
			}
		} else {
			this._actualContent = this._list;

			if (!this._isOGPrint && user.state !== "green") {
				Mapy.getComponent("mymaps").activeComponent(this);
			}

			this._dom.container.appendChild(this._list.container);
			this._detail.container.remove();
			this._list.show();
			this._detail.hide();
		}
	}
}
